import React from 'react'
import Pagination from "../../utils/Pagination";
import { setpageContent } from '../../utils/Constant';
export default function Aepspagination(props) {
    const {table, search,  paginationDetails, isExportable, onExportData, handalpageclick} = props
  return (
    <div class="pager">
    {
      table !== undefined && table !== null && table.length > 0 && search == '' &&
       <p>
       {paginationDetails.currentPage !== undefined && paginationDetails.currentPage !== null  && paginationDetails.totalPost !== undefined && paginationDetails.totalPost !== null &&  table !== undefined && Array.isArray(table) && setpageContent(paginationDetails.currentPage - 1 , table.length, paginationDetails.totalPost)}
       <button  class={isExportable ? 'lbbtn' : 'lbbtn-disable-btn' }  disabled={!isExportable} data-bs-toggle="tooltip" data-bs-placement="top" 
              title="First select the filter than you can export"  type="button" onClick={onExportData}>
         Export
       </button>
     </p>
    }
   
    {
      paginationDetails.totalPost !== undefined && paginationDetails.totalPost !== null && paginationDetails.totalPost > 10 && search == '' &&
     <Pagination
     className="pagination-bar"
     currentPage={paginationDetails.currentPage}
     totalCount={paginationDetails.totalPost}
     pageSize={paginationDetails.postsPerPage}
     onPageChange={page => 
       handalpageclick(page)
     }
     />
      // <Pagination  postsPerPage={paginationDetails.postsPerPage} totalPosts={table.length} paginate={paginate} currentPage={paginationDetails.currentPage} />
     
        }
  </div>
  )
}
